import traderaOrdersApi from '../../repos/tradera-orders'
import timeHasPassed from '../../timeHasPassed'

const state = {
    lastFetchTime: null,
    byStoreId: null,
    filterArchived: false,
    orders: []
};

const getters = {
    getById: state => (id) => {
        return state.orders.find(order => order.id === id);
    },
    hasFetchedForId: state => (id) => {
        return (state.byStoreId === id && state.lastFetchTime !== null);
    }
};

const actions = {
    getAll({ state, commit }, { storeId, filterArchived }) {
        if (
            state.byStoreId === storeId
            && state.filterArchived === filterArchived
            && state.lastFetchTime !== null
            && !timeHasPassed(state.lastFetchTime, 600)
        ) {
            return Promise.resolve();
        }

        return traderaOrdersApi.getAll(storeId, filterArchived)
            .then(response => {
                commit('ordersFetchSuccess', {
                    storeId,
                    filterArchived,
                    orders: response.data
                });
            })
        ;
    },
    archive({ state, commit, getters, dispatch }, orderId) {
        return traderaOrdersApi.archive(state.byStoreId, orderId)
            .then(() => {
                const order = getters.getById(orderId);
                order.sales_items.forEach(item => {
                    commit('salesItems/itemDeleteSuccess', item.id, { root: true });
                });

                commit('orderArchivedSuccess', orderId);
            })
        ;
    },
    merge({ state, commit, getters }, suborders) {
        const orderId = suborders[0];
        suborders.splice(0, 1);

        const order = getters.getById(orderId);
        suborders = [
            ...order.suborders,
            ...suborders
        ];

        const data = {
            suborders
        };

        return traderaOrdersApi.put(state.byStoreId, orderId, data)
            .then((response) => {
                const order = response.data;

                order.sales_items.forEach(item => {
                    commit('salesItems/itemUpdateSuccess', item.id, { root: true });
                });

                order.suborders.forEach(suborder_id => {
                    commit('orderArchivedSuccess', suborder_id);
                });

                commit('orderUpdateSuccess', {
                    orderId,
                    order
                });
            })
        ;
    }
};

const mutations = {
    ordersFetchSuccess(state, { storeId, filterArchived, orders }) {
        state.lastFetchTime = Date.now();
        state.byStoreId = storeId;
        state.filterArchived = filterArchived;
        state.orders = orders;
    },
    orderArchivedSuccess(state, orderId) {
        state.orders = [
            ...state.orders.filter(filterOrder => filterOrder.id !== orderId)
        ];
    },
    orderUpdateSuccess(state, { orderId, order }) {
        state.orders = [
            order,
            ...state.orders.filter(filterOrder => filterOrder.id !== order.id)
        ];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
